import BeautyInsiderCtrl from 'components/Content/BeautyInsider/BeautyInsider.ctrlr';
import BeautyInsiderTabbed from 'components/Content/BeautyInsider/BeautyInsiderTabbed.f';
import { withBeautyInsiderProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderProps';
import { withBeautyInsiderTabbedProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderTabbedProps';
import { isCreativeRefreshPhase2Enabled } from 'utils/BeautyInsider';

const BeautyInsiderLegacy = withBeautyInsiderProps(BeautyInsiderCtrl);
const BeautyInsiderPhase2 = withBeautyInsiderTabbedProps(BeautyInsiderTabbed);

export default isCreativeRefreshPhase2Enabled() ? BeautyInsiderPhase2 : BeautyInsiderLegacy;
